import {Component, Input} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgClass, NgForOf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {BacklogService} from "../../../../core/services/backlog.service";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";

@Component({
  selector: 'app-assign-vehicle',
  standalone: true,
    imports: [
        FormsModule,
        NgForOf,
        ReactiveFormsModule,
        NgClass
    ],
  templateUrl: './assign-vehicle.component.html',
  styleUrl: './assign-vehicle.component.scss'
})
export class AssignVehicleComponent {
    @Input() confirmAction!: () => void;
    @Input() data: any;
    public validate: boolean = false;
    public vehicleForm : FormGroup;
    public vehiclesLis : any = [];

    constructor(public modal:NgbModal,private fb:FormBuilder, public backlogService: BacklogService,
                private generalService: GeneralService,private tableService: TableService) {
        this.vehicleForm = this.fb.group ({
            service_id: new FormControl(0),
            vehicle_id: new FormControl("", Validators.required),
        });
    }

    ngOnInit(){
        this.getVehicles();
    }
    getVehicles(){
        this.backlogService.getVehicle(this.data).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    this.vehiclesLis = res.data;
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        );
    }

    assignVehicle(){
        if (this.vehicleForm.invalid) {
            this.validate = true;
        } else {
            this.vehicleForm.get('service_id')?.setValue(this.data.idService);
            this.backlogService.actionBacklog(this.vehicleForm.value,'assignvehicle').subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.vehicleForm.reset();
                        this.generalService.showMessage('success', res.message);
                        this.confirmAction();
                    }
                },
                (err) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        }
    }

    /**
     * VALIDACIONES INPUTS
     */
    get vehicle() {
        return this.vehicleForm.get("vehicle_id");
    }

}
